module.exports = __webpack_public_path__ + "logo-42abcc348e915d03a0b76fa4ff5f6026.png";